<template>
  <div>
    <el-card style="height:450px;">
      <div slot="header">
        <span>当前逾期情况</span>
      </div>
      <el-row>
        <el-col :span="12">
          <el-row>
            <el-col :span="24">即将到期：{{total1}}</el-col>
          </el-row>
          <el-row class="dv-period" style="height:40px;margin-bottom:0;">
            <el-col :span="24">
              <el-select
                @change="onPeriodChange"
                v-model="dtPeriod"
                placeholder="请选择"
                size="mini"
                style="width:100px;"
              >
                <el-option
                  v-for="period in dtPeriodList"
                  :key="period.key"
                  :label="period.text"
                  :value="period.key"
                ></el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div id="taskStatOverduePie"></div>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="12">
          <el-row>
            <el-col :span="24">已经逾期：{{total2}}</el-col>
          </el-row>
          <div style="width:100%;height:60px;"></div>
          <el-row>
            <el-col :span="24">
              <div id="taskStatOverduedPie"></div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import { GetTaskDelayStats } from "@/api/modules/basicData/task.js";
let echarts = require("echarts");
export default {
  name: "TaskStatOverduePie",
  data() {
    return {
      dtPeriod: "0",
      dtPeriodList: [
        { key: "0", text: "1天内" },
        { key: "1", text: "2天内" },
        { key: "2", text: "3天内" },
        { key: "3", text: "7天内" }
      ],
      total1: 0,
      total2: 0,
      request: {}
    };
  },
  methods: {
    drawOverdue(titles, values) {
      let dom = document.getElementById("taskStatOverduePie");
      if (!dom) {
        return;
      }
      let overdueChart = echarts.init(dom);
      let option = {
        title: {
          show: false,
          bottom: 0
        },
        tooltip: {
          trigger: "item",
          formatter: "{b} : {c} ({d}%)"
        },
        legend: {
          bottom: 10,
          left: "center",
          data: titles
        },
        series: [
          {
            type: "pie",
            radius: "60%",
            center: ["50%", "50%"],
            label: {
              normal: {
                show: false
              }
            },
            lableLine: {
              normal: {
                show: false
              }
            },
            data: [
              {
                value: values[0],
                name: "进度逾期",
                itemStyle: {
                  color: "#E6A23C"
                }
              },
              {
                value: values[1],
                name: "操作超期",
                itemStyle: {
                  color: "#c23531"
                }
              }
            ],
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ]
      };
      overdueChart.setOption(option);
    },
    drawOverdued(titles, values) {
      let dom = document.getElementById("taskStatOverduedPie");
      if (!dom) {
        return;
      }
      let overduedChart = echarts.init(dom);
      let option = {
        title: {
          show: false,
          bottom: 0
        },
        tooltip: {
          trigger: "item",
          formatter: "{b} : {c} ({d}%)"
        },
        legend: {
          bottom: 10,
          left: "center",
          data: titles
        },
        series: [
          {
            type: "pie",
            radius: "60%",
            center: ["50%", "50%"],
            label: {
              normal: {
                show: false
              }
            },
            lableLine: {
              normal: {
                show: false
              }
            },
            data: [
              {
                value: values[0],
                name: "进度逾期",
                itemStyle: {
                  color: "#E6A23C"
                }
              },
              {
                value: values[1],
                name: "操作超期",
                itemStyle: {
                  color: "#c23531"
                }
              }
            ],
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ]
      };
      overduedChart.setOption(option);
    },
    refresh(request) {
      this.request = request;
      GetTaskDelayStats({
        TimeType: 0,
        TimeRange: this.dtPeriod,
        UserId: request.UserId,
        TaskIds: request.TaskIds || "",
        Paras: request.Paras || {},
        ServerCenterId: request.ServerCenterId || ""
      })
        .then(res => {
          let res1 = res["m_Item1"];
          let res2 = res["m_Item2"];
          let titles1 = [];
          let values1 = [];
          if (res1 && res1.length > 0) {
            titles1 = res1.map(task => task.Name);
            values1 = res1.map(task => task.Value);
          }
          this.drawOverdue(titles1, values1);
          this.total1 = parseInt(values1[0]) + parseInt(values1[1]);

          let titles2 = [];
          let values2 = [];
          if (res2 && res2.length > 0) {
            titles2 = res2.map(task => task.Name);
            values2 = res2.map(task => task.Value);
          }
          this.drawOverdued(titles2, values2);
          this.total2 = parseInt(values2[0]) + parseInt(values2[1]);
        })
        .catch(error => {
          console.log(error);
          // this.$message.error("获取统计数据失败");
        });
    },
    onPeriodChange() {
      console.log("asd");
      this.refresh(this.request);
    }
  }
};
</script>

<style lang="less" scoped>
.dv-period {
  margin: 20px 0;
}
#taskStatOverduePie,
#taskStatOverduedPie {
  width: 100%;
  height: 265px;
  margin-top: -20px;
}
</style>
